import { dataConfig } from 'data/dataConfig';

/**
 * A first-load task is finished once it completed or errored; either way the scrape is over.
 */
export const isFirstLoadTaskFinished = (task) => !!task?.complete || !!task?.errored_at;

/**
 * Names of the first-load tasks still running for the current property.
 */
export const buildInProgressTaskNames = (firstLoadTasksData) => {
	const names = new Set();
	(firstLoadTasksData || []).forEach((task) => {
		if (!isFirstLoadTaskFinished(task)) {
			names.add(task.task_name);
		}
	});
	return names;
};

/**
 * The first-load task names a sidebar row waits on. A combined row waits on every source it is
 * assembled from (dataConfig combinedFrom), so its loader runs until the last of them finishes.
 */
export const getFirstLoadTaskNames = (dataSet, dataSource) => {
	const config = dataConfig[dataSet];
	if (!config) {
		return [];
	}
	if (config.combinedFrom) {
		return config.combinedFrom.flatMap((source) =>
			getFirstLoadTaskNames(source.dataSet, source.dataSource),
		);
	}
	const taskName = config.firstLoadTaskNames?.[dataSource];
	return taskName ? [taskName] : [];
};

/**
 * Whether a sidebar row should show its loader: any task it waits on is still running.
 */
export const isDataSetLoading = (dataSet, dataSource, inProgressTaskNames) =>
	getFirstLoadTaskNames(dataSet, dataSource).some((taskName) =>
		inProgressTaskNames.has(taskName),
	);

/**
 * Whether every first-load task for the property has finished (the toolbar's loading icon).
 */
export const areFirstLoadTasksFinished = (firstLoadTasks) =>
	Array.isArray(firstLoadTasks) && firstLoadTasks.every(isFirstLoadTaskFinished);

/**
 * Whether the property's first load is still running (any known task unfinished).
 */
export const isFirstLoadInProgress = (firstLoadTasks) =>
	Array.isArray(firstLoadTasks) && firstLoadTasks.some((task) => !isFirstLoadTaskFinished(task));
